export default function() {
	return {
		loading: false,
		users: [],
		showNewUserModal: false,
		newUserData: {
			name: '',
			email: '',
			super: false,
			r10Id: null,
		},
	};
}
